import codes from '@/assets/codes.json'

const year_welcome = {
    2024: 'https://image.tmdb.org/t/p/original/24Ov8wnusgnzXwjV1eDm0Lzo5da.jpg',
    2023: 'https://image.tmdb.org/t/p/original/kGWpZewzInbzTuaIHcy0bFgzXuM.jpg',
    2022: 'https://www.themoviedb.org/t/p/original/e782pDRAlu4BG0ahd777n8zfPzZ.jpg',
    2021: 'https://image.tmdb.org/t/p/original/lzWHmYdfeFiMIY4JaMmtR7GEli3.jpg',
    2020: 'https://image.tmdb.org/t/p/original/2lBOQK06tltt8SQaswgb8d657Mv.jpg',
    2019: 'https://www.themoviedb.org/t/p/original/e7CE5vx4KqUuz0peKdHRVZB0Pn8.jpg',
    2018: 'https://www.themoviedb.org/t/p/original/j0r7xM9EZefMfK28OFSs9u2nN3t.jpg',
    2017: 'https://www.themoviedb.org/t/p/original/9AU3kxNMM6AGofeC1uOtm4etsNj.jpg',
    2016: 'https://www.themoviedb.org/t/p/original/kJowcKv68iQQGerduSeEKbPwrKi.jpg',
    2015: 'https://www.themoviedb.org/t/p/original/yBG2J4dMnUViwfF1crq0b7xystj.jpg',
    2014: 'https://www.themoviedb.org/t/p/original/caQp2MhwfrTYGqVr7d9ayn8tqQ7.jpg',
    2013: 'https://www.themoviedb.org/t/p/original/dliT4dh9r23PGx3qMOnJXXybbN4.jpg',
    2012: 'https://www.themoviedb.org/t/p/original/wxZZYc7kHObKymA6mx0PBqh8rRl.jpg',
    2011: 'https://www.themoviedb.org/t/p/original/4ZyVdTzUSnxWFl8r4rjHPLVr0Dg.jpg',
    2010: 'https://www.themoviedb.org/t/p/original/vbpD32PkAVXFnl5GiNlT0gvi4gX.jpg',
}   

const languageNames = codes


export { year_welcome, languageNames }
